<template>
  <div class="layout">
    <div class="header">
      <div class="logo">
        <i class="el-icon-orange"></i>
        虾塘养殖管理系统
      </div>
      <div class="user-info">
        <el-dropdown>
          <span class="el-dropdown-link">
            <el-avatar
              :size="36"
              :src="currentUser?.userAvatar || defaultAvatar"
              style="margin-right: 10px; cursor: pointer"
            ></el-avatar>
            {{ currentUser?.userName || currentUser?.name || "用户"
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="openProfileDialog"
                >个人信息</el-dropdown-item
              >
              <el-dropdown-item divided @click="logout"
                >退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>

    <!-- 个人信息弹窗 -->
    <el-dialog
      v-model="profileDialogVisible"
      title="个人信息"
      width="550px"
      :close-on-click-modal="false"
    >
      <el-form
        :model="profileForm"
        :rules="profileRules"
        ref="profileFormRef"
        label-width="100px"
        v-loading="profileLoading"
      >
        <el-form-item label="用户名" prop="userName">
          <el-input
            v-model="profileForm.userName"
            placeholder="请输入用户名"
          ></el-input>
        </el-form-item>
        <el-form-item label="真实姓名">
          <el-input v-model="profileForm.realName" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="profileForm.phone"
            disabled
            placeholder="手机号不可修改"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户角色">
          <el-input v-model="displayRole" disabled></el-input>
        </el-form-item>
        <el-form-item label="用户头像">
          <div class="avatar-upload-container">
            <el-avatar
              :size="80"
              :src="profileForm.userAvatar || defaultAvatar"
              class="avatar-preview"
            />
            <div class="avatar-actions">
              <el-upload
                class="avatar-uploader"
                action="#"
                :show-file-list="false"
                :http-request="customUpload"
                :before-upload="beforeAvatarUpload"
                accept="image/*"
              >
                <el-button type="primary" size="small" :icon="Upload">
                  选择图片
                </el-button>
              </el-upload>
              <el-button
                v-if="profileForm.userAvatar"
                type="danger"
                size="small"
                :icon="Delete"
                @click="handleRemoveAvatar"
              >
                移除头像
              </el-button>
            </div>
            <div class="avatar-tip">支持 JPG、PNG 格式，文件小于 10MB</div>
          </div>
        </el-form-item>
        <el-form-item label="个人简介" prop="userProfile">
          <el-input
            v-model="profileForm.userProfile"
            type="textarea"
            :rows="3"
            placeholder="请输入个人简介"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="profileDialogVisible = false">取消</el-button>
        <el-button @click="handleResetProfile">重置</el-button>
        <el-button type="primary" @click="handleSaveProfile" :loading="saving">
          保存修改
        </el-button>
      </template>
    </el-dialog>

    <div class="main-container">
      <div class="sidebar">
        <div class="menu-title">主菜单</div>
        <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          background-color="#2a3f4e"
          text-color="#fff"
          active-text-color="#ffd04b"
          :unique-opened="true"
          router
        >
          <el-menu-item index="/dashboard">
            <i class="el-icon-data-line"></i>
            <span>控制台</span>
          </el-menu-item>

          <el-sub-menu index="2">
            <template #title>
              <i class="el-icon-user"></i>
              <span>用户管理</span>
            </template>
            <el-menu-item index="/users">用户列表</el-menu-item>
            <el-menu-item v-if="canViewUsage" index="/user-usage"
              >使用统计</el-menu-item
            >
          </el-sub-menu>

          <el-sub-menu index="3">
            <template #title>
              <i class="el-icon-help"></i>
              <span>虾塘管理</span>
            </template>
            <el-menu-item index="/ponds">虾塘列表</el-menu-item>
            <el-menu-item index="/pond-map">地图视图</el-menu-item>
            <el-menu-item index="/all-ponds" v-if="isAdmin"
              >全部虾塘</el-menu-item
            >
          </el-sub-menu>

          <el-sub-menu index="4">
            <template #title>
              <i class="el-icon-cpu"></i>
              <span>装置管理</span>
            </template>
            <el-menu-item index="/devices">装置列表</el-menu-item>
            <el-menu-item index="/device-results">检测结果</el-menu-item>
            <el-menu-item index="/device-videos">设备视频</el-menu-item>
            <el-menu-item v-if="canViewUsage" index="/ota"
              >OTA 升级管理</el-menu-item
            >
          </el-sub-menu>

          <!--          <el-sub-menu index="5">-->
          <!--            <template #title>-->
          <!--              <i class="el-icon-bell"></i>-->
          <!--              <span>报警管理</span>-->
          <!--            </template>-->
          <!--            <el-menu-item index="/alerts">待处理报警</el-menu-item>-->
          <!--            <el-menu-item index="/alert-history">报警历史</el-menu-item>-->
          <!--          </el-sub-menu>-->
        </el-menu>
      </div>

      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { logout as apiLogout } from "@/api/login";
import { getCurrentUser, updateSelfProfile } from "@/api/user";
import instance from "@/api/axiosInstance";
import { computed, onMounted, ref, reactive } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ElMessageBox, ElMessage, ElLoading } from "element-plus";
import { Upload, Delete } from "@element-plus/icons-vue";

export default {
  name: "CommonLayout",
  setup() {
    const store = useStore();
    const router = useRouter();
    const isLogoutLoading = ref(false);

    // 默认头像
    const defaultAvatar =
      "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png";

    // 自定义上传方法
    const customUpload = async (options) => {
      const { file } = options;
      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await instance.post("/file/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.data.code === 0 && response.data.data) {
          profileForm.userAvatar = response.data.data;
          ElMessage.success("头像上传成功");
        } else {
          ElMessage.error(response.data.message || "头像上传失败");
        }
      } catch (error) {
        console.error("头像上传失败:", error);
        ElMessage.error("头像上传失败，请重试");
      }
    };

    // 角色映射
    const roleMap = {
      employee: "员工",
      admin: "管理员",
      superAdmin: "超级管理员",
      boss: "老板",
    };

    // 个人信息弹窗相关
    const profileDialogVisible = ref(false);
    const profileFormRef = ref(null);
    const profileLoading = ref(false);
    const saving = ref(false);
    const originalProfileForm = ref({});

    const profileForm = reactive({
      id: "",
      userName: "",
      realName: "",
      phone: "",
      userRole: "",
      userAvatar: "",
      userProfile: "",
    });

    const profileRules = reactive({
      userName: [{ required: true, message: "请输入用户名", trigger: "blur" }],
      userProfile: [
        { max: 500, message: "个人简介不能超过500个字符", trigger: "blur" },
      ],
    });

    // 显示用的角色名称
    const displayRole = computed(() => {
      return roleMap[profileForm.userRole] || profileForm.userRole || "";
    });

    // 添加默认用户信息
    const defaultUser = ref({
      name: "用户",
      avatar: "",
      role: "user",
    });

    const isAdmin = computed(() => store.getters.isAdmin);
    const canViewUsage = computed(() => store.getters.isAdminOrAbove);
    const currentUser = computed(() => {
      const user = store.getters.currentUser;
      // 如果用户信息为null或undefined，返回默认值
      return user || defaultUser.value;
    });

    // 获取当前用户信息
    const fetchUserProfile = async () => {
      profileLoading.value = true;
      try {
        const response = await getCurrentUser();
        if (response.code === 0 && response.data) {
          const userData = response.data;
          Object.assign(profileForm, {
            id: userData.id || "",
            userName: userData.userName || "",
            realName: userData.realName || "",
            phone: userData.phone || "",
            userRole: userData.userRole || "",
            userAvatar: userData.userAvatar || "",
            userProfile: userData.userProfile || "",
          });
          // 保存原始数据用于重置
          originalProfileForm.value = { ...profileForm };
          // 更新 store 中的用户信息
          store.commit("setUser", userData);
        } else {
          ElMessage.error(response.message || "获取用户信息失败");
        }
      } catch (error) {
        console.error("获取用户信息失败:", error);
        ElMessage.error("获取用户信息失败");
      } finally {
        profileLoading.value = false;
      }
    };

    // 打开个人信息弹窗
    const openProfileDialog = async () => {
      profileDialogVisible.value = true;
      await fetchUserProfile();
    };

    // 头像上传前校验
    const beforeAvatarUpload = (file) => {
      const isImage = file.type.startsWith("image/");
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isImage) {
        ElMessage.error("只能上传图片文件!");
        return false;
      }
      if (!isLt10M) {
        ElMessage.error("图片大小不能超过 10MB!");
        return false;
      }
      return true;
    };

    // 移除头像
    const handleRemoveAvatar = () => {
      profileForm.userAvatar = "";
      ElMessage.success("头像已移除");
    };

    // 保存个人信息
    const handleSaveProfile = () => {
      if (!profileFormRef.value) return;

      profileFormRef.value.validate(async (valid) => {
        if (valid) {
          saving.value = true;
          try {
            const updateData = {
              id: profileForm.id,
              userName: profileForm.userName,
              userAvatar: profileForm.userAvatar,
              userProfile: profileForm.userProfile,
              updateTime: new Date().toISOString(),
            };

            const response = await updateSelfProfile(updateData);

            if (response.code === 0) {
              ElMessage.success("修改成功");
              await fetchUserProfile();
              profileDialogVisible.value = false;
            } else {
              ElMessage.error(response.message || "修改失败");
            }
          } catch (error) {
            console.error("修改个人信息失败:", error);
            ElMessage.error("修改失败，请重试");
          } finally {
            saving.value = false;
          }
        }
      });
    };

    // 重置表单
    const handleResetProfile = () => {
      Object.assign(profileForm, originalProfileForm.value);
    };

    // 初始化用户信息
    onMounted(async () => {
      // 获取用户信息
      try {
        const response = await getCurrentUser();
        if (response.code === 0 && response.data) {
          store.commit("setUser", response.data);
        }
      } catch (error) {
        console.error("初始化用户信息失败:", error);
      }
    });

    // 清除登录相关信息
    const clearLoginInfo = () => {
      // 清除localStorage中的信息
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("accessExpiresIn");
      localStorage.removeItem("refreshExpiresIn");
      localStorage.removeItem("accessExpiryTime");
      localStorage.removeItem("refreshExpiryTime");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("openIdWeb");
      localStorage.removeItem("userId");

      // 清除Vuex中的用户信息
      store.commit("setUser", null);
      store.commit("setLoginStatus", false);
    };

    const logout = async () => {
      ElMessageBox.confirm("确定要退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          isLogoutLoading.value = true;
          const loadingInstance = ElLoading.service({
            lock: true,
            text: "退出中...",
            background: "rgba(0, 0, 0, 0.7)",
          });

          try {
            // 调用退出登录接口
            const logoutRes = await apiLogout();

            if (logoutRes.code === 0) {
              // 清除登录信息
              clearLoginInfo();
              // 跳转到登录页（使用replace避免返回）
              router.replace("/login");
              ElMessage.success(logoutRes.message || "退出登录成功");
            } else {
              throw new Error(logoutRes.message || "退出登录失败");
            }
          } catch (error) {
            console.error("退出登录失败:", error);
            // 即使接口失败也清除本地信息
            clearLoginInfo();
            router.replace("/login");
            ElMessage.error(error.message || "退出失败，请重试");
          } finally {
            isLogoutLoading.value = false;
            loadingInstance.close();
          }
        })
        .catch(() => {
          // 取消退出
        });
    };

    return {
      Upload,
      Delete,
      isAdmin,
      canViewUsage,
      currentUser,
      defaultAvatar,
      profileDialogVisible,
      profileFormRef,
      profileForm,
      profileRules,
      profileLoading,
      saving,
      displayRole,
      openProfileDialog,
      customUpload,
      beforeAvatarUpload,
      handleRemoveAvatar,
      handleSaveProfile,
      handleResetProfile,
      logout,
      isLogoutLoading,
    };
  },
};
</script>

<style scoped>
.layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.header {
  background-color: #1b9a7c;
  color: white;
  padding: 0 20px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.logo {
  font-size: 22px;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.logo i {
  margin-right: 10px;
  font-size: 24px;
}

.user-info {
  display: flex;
  align-items: center;
}

.main-container {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.sidebar {
  width: 220px;
  background-color: #2a3f4e;
  color: #fff;
  overflow-y: auto;
}

.content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

.menu-title {
  padding: 15px 20px;
  font-size: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: #a6b3bf;
}

.el-menu {
  border-right: none;
}

.el-menu-item,
.el-sub-menu__title {
  color: #e0e0e0;
}

.el-menu-item:hover,
.el-sub-menu__title:hover {
  background-color: #1b9a7c !important;
  color: #fff;
}

.avatar-upload-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.avatar-preview {
  border: 2px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.avatar-actions {
  display: flex;
  gap: 10px;
}

.avatar-tip {
  font-size: 12px;
  color: #909399;
}

.avatar-uploader {
  display: inline-block;
}

.el-menu-item.is-active {
  background-color: #1b9a7c !important;
  color: #fff;
}
</style>
